import React, { useContext } from 'react';
import ContextDemanda from '@app/hooks/useQuestionario';
import { getLoggedId } from '@app/helpers';
import { Demanda } from '@app/api/demanda';
import ModalDevolverDemandaGestorTecnico from './ModalDevolverDemandaGestorTecnico';
import ModalValidarDemandaGestorTecnico from './ModalValidarDemandaGestorTecnico';

interface Props {
  demanda: Demanda;
}

const FooterAbaSumario = ({ demanda }: Props) => {
  const { setUpdate, update } = useContext(ContextDemanda);

  const onUpdate = () => {
    setUpdate(!update);
  };

  return (
    <div className="ant-app-form-actions">
      {getLoggedId() === demanda.gestorTecnicoId ? (
        <>
          {demanda.statusCodigo === 14 ? (
            <>
              <ModalValidarDemandaGestorTecnico onUpdate={onUpdate} demanda={demanda} />
              <ModalDevolverDemandaGestorTecnico onUpdate={onUpdate} demanda={demanda} />
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default FooterAbaSumario;
